import React, { useState, useEffect } from "react";
import qs from "query-string";
import { Container, Row, Col } from "reactstrap";
import CardSection from "../Card/Card";
import plusIcon from "../../assets/plus-icon.svg";
import DropdowFilter from "../../components/DropdownFilter/DropdownFilter";
import useApi from "../../hooks/useApi";

// import styles from "./Resources/ResourcesCards.module.scss";
import styles from "./TheLatest.module.scss";

const TheLatest = ({ limit = 16 }) => {
  const [page, setPage] = useState(1);
  const [selectedFilters, setSelectedFilters] = useState({});
  const filter = { ...selectedFilters, limit, page };
  const qsOptions = { arrayFormat: "bracket" };
  const filterQueryString = qs.stringify(filter, qsOptions);
  const [posts, setPosts] = useState([]);
  // Get posts from API
  const [{ data, loading }, getPublications] = useApi(`get/posts?${filterQueryString}`);
  const isLastPage = page === data?.pagination?.total_pages * 1;

  useEffect(() => {
    if (data && data.posts && data.posts.length && !posts.length) {
      setPosts(data.posts);
    }
  }, [data]);

  const loadMore = async (e) => {
    e.preventDefault();
    const filterQueryString = qs.stringify({ ...filter, page: page + 1 }, { arrayFormat: "bracket" });
    const { data } = await getPublications(`get/posts?${filterQueryString}`);
    setPage(page + 1);
    setPosts([...posts, ...(data.posts || [])]);
  };

  const toggleFilter = (name, value) => async (e) => {
    if (typeof e?.preventDefault === "function") e.preventDefault();
    const filterQueryString = qs.stringify({ ...filter, [name]: value, page: 1 }, qsOptions);
    // console.log({ filterQueryString });
    const { data } = await getPublications(`get/posts?${filterQueryString}`);
    setSelectedFilters({ ...selectedFilters, [name]: value });
    setPage(1);
    setPosts(data.posts || []);
  };

  const filters = data?.filters;
  const selectFilter = (e) => {
    const { name, value } = e.target;
    toggleFilter(name, value ? value : undefined)(e);
  };

  return (
    <div>
      <Row className={styles.latestSection}>
        <Col xs="12" md="6" className="px-1">
          <h5>Browse the latest</h5>
        </Col>
        <Col xs="12" md="6" className="d-flex justify-content-end px-0 pr-1 flex-wrap">
          <div>Filter by:</div>
          <ul className={styles.filters}>
            {filters?.locations ? (
              <li>
                <DropdowFilter
                  name="state"
                  title="Location"
                  defaultOptions={filters?.locations}
                  onChange={selectFilter}
                />
              </li>
            ) : null}
            {filters?.categories ? (
              <li>
                <DropdowFilter
                  name="category"
                  title="Categories"
                  defaultOptions={filters?.categories}
                  onChange={selectFilter}
                />
              </li>
            ) : null}
          </ul>
        </Col>
      </Row>
      <Row>
        <Col>
          <Row className="h-100">
            {!posts.length ? (
              <Col xs={12} className="text-center">
                {loading ? (
                  <p style={{ marginTop: 30 }}>Loading..</p>
                ) : (
                  <p style={{ marginTop: 30 }}>No matches found, please try another search</p>
                )}
              </Col>
            ) : (
              posts.map((content) => (
                <Col xs={12} md={6} className="px-1 py-1">
                  <CardSection data={content} cardImage={true} />
                </Col>
              ))
            )}
          </Row>
        </Col>
      </Row>
      <Row className="py-4 px-2 px-md-0">
        {posts.length && !isLastPage ? (
          <Col className="text-center">
            <a href="/" onClick={loadMore} className={styles.sectionLink}>
              {loading ? (
                <span>Loading..</span>
              ) : (
                <>
                  Load {limit} more resources
                  <img
                    src={plusIcon}
                    style={{
                      height: 11.5,
                      marginLeft: "0.5rem",
                      marginBottom: "0.1rem",
                    }}
                  />
                </>
              )}
            </a>
          </Col>
        ) : null}
      </Row>
    </div>
  );
};

export default TheLatest;
